/**
 * Verify user screen
 * Verify user email after signup
 * After successful verification the user is logged in automatically and redirected to the create profile screen
 */
import React from "react"
import { ThemeProvider } from "styled-components"
import theme from "styles/theme-main"
import { format } from "date-fns"
import {
  EventWrapper,
  LeftColumn,
  RightColumn,
  EventImage,
  EventDetails,
  EventDetailsMobile,
  EventDetialsWrapper,
  EventTitle,
  EventTitleWrapper,
  EventInfomation,
  EventInformationWrapper,
  InformationCont,
  EventInformationLabel,
  EventInformationData,
  H2,
  H3,
  P,
  Link,
  RegisterButtonForMobile,
  RegisterButtonForDesktop,
} from "./styles"
import Button from "components/Button"
import { formatEventTime, isBeforeEventEndTime, getTimezone } from "utils/utils"
import { isCandidXMode } from "utils/productUtils"

export class EventInformation extends React.Component {
  register = () => {
    this.setState({
      isRegisterModal: true,
    })
  }

  render() {
    const { organization, event, register } = this.props
    const time = new Date().getTime()
    const belowCapacity =
      event.capacity === null || event.candidates < event.capacity

    const timezone = getTimezone()

    return (
      <ThemeProvider theme={theme}>
        <EventWrapper>
          <LeftColumn>
            <EventImage
              bgColor={event.imageUrl ? "#ffffff" : theme.colors.primary}
            >
              {event.imageUrl && (
                <img
                  id={time}
                  alt={event.name}
                  src={`${event.imageUrl}?id=${time}`}
                />
              )}
            </EventImage>
            <EventDetails>
              <EventDetialsWrapper>
                <H2>EVENT DETAILS</H2>
                {event.status === "ACTIVE" &&
                isBeforeEventEndTime(event) &&
                belowCapacity ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: event.description }}
                  />
                ) : (
                  <div>
                    {event.status === "ACTIVE" && belowCapacity
                      ? "The event has now ended"
                      : "Registration for this event is no longer available."}
                  </div>
                )}
              </EventDetialsWrapper>
            </EventDetails>
          </LeftColumn>
          <RightColumn>
            <EventTitle>
              <EventTitleWrapper>
                <div>
                  <H3>{event.name}</H3>
                  <P>by {organization.name}</P>
                </div>
                <RegisterButtonForDesktop>
                  {isBeforeEventEndTime(event) &&
                    event.status === "ACTIVE" &&
                    belowCapacity &&
                    !isCandidXMode() && (
                      <Button label="Register" onClick={register} />
                    )}
                </RegisterButtonForDesktop>
              </EventTitleWrapper>
            </EventTitle>
            <EventInfomation>
              <EventInformationWrapper>
                <InformationCont>
                  <EventInformationLabel>Date</EventInformationLabel>
                  <EventInformationData>
                    {format(event.eventStartDate, "dd/MM/yyyy")}
                  </EventInformationData>
                </InformationCont>

                <InformationCont>
                  <EventInformationLabel>Time</EventInformationLabel>
                  <EventInformationData>
                    {formatEventTime(event.eventStartDate, event.eventEndDate)}
                    {timezone}
                  </EventInformationData>
                </InformationCont>

                <InformationCont>
                  <EventInformationLabel>
                    {event.type === "ONLINE" ? "Link" : "Location"}
                  </EventInformationLabel>
                  {event.type === "ONLINE" ? (
                    <EventInformationData>
                      <P>A joining link will be shared post registration.</P>
                    </EventInformationData>
                  ) : (
                    <EventInformationData>
                      {event.venue && (
                        <React.Fragment>
                          {event.venue}
                          <br />
                        </React.Fragment>
                      )}
                      {event.line1 && (
                        <React.Fragment>
                          {event.line1}
                          <br />
                        </React.Fragment>
                      )}
                      {event.line2 && (
                        <React.Fragment>
                          {event.line2}
                          <br />
                        </React.Fragment>
                      )}
                      {event.town && (
                        <React.Fragment>
                          {event.town}
                          <br />
                        </React.Fragment>
                      )}
                      {event.postCode && (
                        <React.Fragment>
                          {event.postCode}
                          <br />
                          <br />
                        </React.Fragment>
                      )}
                      <Link
                        rel="noopener noreferrer"
                        target="_blank"
                        href={`https://maps.google.com/maps?q=${event.postCode}`}
                      >
                        View on Map
                      </Link>
                    </EventInformationData>
                  )}
                </InformationCont>
              </EventInformationWrapper>
            </EventInfomation>
            <EventDetailsMobile>
              <EventDetialsWrapper>
                <H2>EVENT DETAILS</H2>
                {event.status === "ACTIVE" &&
                isBeforeEventEndTime(event) &&
                belowCapacity ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: event.description }}
                  />
                ) : (
                  <div>
                    {event.status === "ACTIVE" && belowCapacity
                      ? "The event has now ended"
                      : "Registration for this event is no longer available."}
                  </div>
                )}
              </EventDetialsWrapper>
            </EventDetailsMobile>
          </RightColumn>
          <RegisterButtonForMobile>
            {isBeforeEventEndTime(event) &&
              event.status === "ACTIVE" &&
              belowCapacity &&
              !isCandidXMode() && (
                <Button label="Register" onClick={register} />
              )}
          </RegisterButtonForMobile>
        </EventWrapper>
      </ThemeProvider>
    )
  }
}

export default EventInformation
